import OfficeLine from '@component/card/listings/office/line'
import ABTest from '@component/abTest'
import AgentsCarousel from '@component/card/agent/carousel'
import AgentGallery, { VillagerGallery } from '@component/card/agent/gallery'
import FavouriteButton from '@component/card/listings/favourite'
import TrackButton from '@component/card/listings/track'
import useGallery from '@hooks/useGallery'
import { joinStr } from '@utils'
import { isShowFavoriteButton, isShowTrackButton, isVillageData } from '@utils/house'
import classNames from 'classnames'
import { get, map, take } from 'lodash-es'
import { AgentOffice } from '../../info/agents'


export default function GalleryAside({
  className
}) {

  const {
    house
  } = useGallery()

  const isVillage = isVillageData(house)
  const agents = isVillage ? [] : take(get(house, 'agents', []), 2)
  return (
    <section className={classNames('pt-30 px-10 pb-10 w-348 hidden space-y-8 overflow-auto lg:block sm:ml-10 xl:ml-30', className)}>
      {
        isShowFavoriteButton(house) && (
          <FavouriteButton data={house} signupSource='Save_Property' id='save_listing_image_gallery'></FavouriteButton>
        )
      }
      {
        isShowTrackButton(house) && (
          <TrackButton data={house} signupSource='Track_Home' className='rounded-4xl'></TrackButton>
        )
      }
      <div className='text-font text-xl'>{joinStr([house.street, house.suburb, house.district], ', ')}</div>
      <div className='text-neutral-5 text-base'>{house.teaser}</div>
      <div className='!mt-16 space-y-16'>
        {
          isVillage
            ? (
              <VillagerGallery house={house} />
            )
            : (
              <ABTest
                newComponent={
                  <div className='shadow-md rounded-sm overflow-hidden'>
                    <OfficeLine data={house} className='!h-50' center iconHeight={32}></OfficeLine>
                    <div className='p-20 pt-10'>
                      <AgentsCarousel
                        data={get(house, 'agents', [])}
                      >
                        <AgentOffice data={house} showOfficeName={false} />
                      </AgentsCarousel>
                    </div>
                  </div>
                }
              >
                {
                  map(agents, item => (
                    <AgentGallery data={item} house={house} key={item.id}></AgentGallery>
                  ))
                }
              </ABTest>
            )
        }
      </div>
    </section>
  )
}